import { baseGoerliTokens } from '@pancakeswap/tokens'
import { FeeAmount } from '@pancakeswap/v3-sdk'
import { defineFarmV3Configs } from '../src/defineFarmV3Configs'

export const farmsV3 = defineFarmV3Configs([
  {
    pid: 1,
    lpAddress: '0x37142c3b588d498fde8bd6d1a5b0c5e7061ecd76',
    token0: baseGoerliTokens.usdc,
    token1: baseGoerliTokens.weth,
    feeAmount: FeeAmount.MEDIUM,
  },
  {
    pid: 14,
    lpAddress: '0x680Be68541c31591Ce521e22d3f4fcF305Fa5D49',
    token0: baseGoerliTokens.usdt,
    token1: baseGoerliTokens.weth,
    feeAmount: FeeAmount.MEDIUM,
  },
  {
    pid: 2,
    lpAddress: '0xE05bf63998DA677d1825846A4B8913B86E460db5',
    token0: baseGoerliTokens.weth,
    token1: baseGoerliTokens.dackie,
    feeAmount: FeeAmount.MEDIUM,
  },
  {
    pid: 3,
    lpAddress: '0xAFDE3dCb89F03C47B5DfA1291fE57bE78010893e',
    token0: baseGoerliTokens.weth,
    token1: baseGoerliTokens.wbtc,
    feeAmount: FeeAmount.MEDIUM,
  },
  {
    pid: 4,
    lpAddress: '0xd2DCCB704631EAe3aCC5Bad175b2a3949B95F059',
    token0: baseGoerliTokens.weth,
    token1: baseGoerliTokens.quack2,
    feeAmount: FeeAmount.MEDIUM,
  },
  {
    pid: 11,
    lpAddress: '0x427EA75701D34D1833d4271d679c840a92534DEC',
    token0: baseGoerliTokens.weth,
    token1: baseGoerliTokens.steth,
    feeAmount: FeeAmount.LOW,
  },
  {
    pid: 12,
    lpAddress: '0x4aD345245e08AdDeE5d350Df4cFaef71FAB9ef80',
    token0: baseGoerliTokens.weth,
    token1: baseGoerliTokens.cbeth,
    feeAmount: FeeAmount.LOW,
  },
  {
    pid: 5,
    lpAddress: '0x7032366b63689d9603e7a3Cd16B36b1fB34494be',
    token0: baseGoerliTokens.weth,
    token1: baseGoerliTokens.boss,
    feeAmount: FeeAmount.MEDIUM,
  },
  {
    pid: 6,
    lpAddress: '0xE72504e9734f2fFDae51C83e3d02A6947FE6F70c',
    token0: baseGoerliTokens.weth,
    token1: baseGoerliTokens.doodoo,
    feeAmount: FeeAmount.MEDIUM,
  },
  {
    pid: 7,
    lpAddress: '0xF33447522333215b89FE1284E3E0f9841B56796d',
    token0: baseGoerliTokens.volo,
    token1: baseGoerliTokens.weth,
    feeAmount: FeeAmount.MEDIUM,
  },
  {
    pid: 8,
    lpAddress: '0x89F2b3104993c31af0fF8c623bb74b036f9B0Ad7',
    token0: baseGoerliTokens.tblx,
    token1: baseGoerliTokens.weth,
    feeAmount: FeeAmount.MEDIUM,
  },
  {
    pid: 9,
    lpAddress: '0x1B8976744A13bc7cbFa2654D177D64AEa42274C0',
    token0: baseGoerliTokens.weth,
    token1: baseGoerliTokens.avnt,
    feeAmount: FeeAmount.MEDIUM,
  },
  {
    pid: 10,
    lpAddress: '0x1AE39BDA60847927a338DFF6f39b455cA9DE6CBF',
    token0: baseGoerliTokens.weth,
    token1: baseGoerliTokens.punkbase,
    feeAmount: FeeAmount.MEDIUM,
  }

])
